import { createFileRoute } from "@tanstack/react-router";
import { SshKeys } from "../../features/account/ssh-keys";

export const Route = createFileRoute("/_authed/account/sshkeys")({ component: SshKeys });
